import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { actions } from '../../actions/actionsWrapper';
import { IThongTinCbnv } from '../../../models/response/hoc-sinh/IThongTinCbnv';
import { eThongTinCbnvActionTypeIds, IThongTinCbnvActionTypes } from '../../action-types/thongtin-cbnv/IThongTinCbnvActionTypes';


export function* thongTinCbnvSaga(): any {
    yield takeLatest(eThongTinCbnvActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eThongTinCbnvActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eThongTinCbnvActionTypeIds.DELETE_START, deleteWorker)


}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.thongTinCbnv.select_all)
    if (res.is_success) {
        yield put(actions.thongTinCbnv.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.thongTinCbnv.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IThongTinCbnvActionTypes): any {
    const payload: IThongTinCbnv = action.payload as IThongTinCbnv;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.thongTinCbnv.update, payload)
    } else {
        res = yield call(apiWrapper.thongTinCbnv.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.thongTinCbnv.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.thongTinCbnv.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IThongTinCbnvActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.thongTinCbnv.delete, payload)
    if (res.is_success) {
        yield put(actions.thongTinCbnv.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.thongTinCbnv.DELETE_ERROR(res.message ?? "Error"))
    }
}
